import { isBrowser } from 'helpers/helper';
import React, { type FC, Fragment, type ReactElement, Suspense, lazy } from 'react';

import { type AudioProps } from './AudioPlayer';
import AudioPlayerTemplate, { type AudioTemplateProps } from './AudioPlayerTemplate';

const AudioPlayer = lazy(() => import('./AudioPlayer'));

const Audio: FC<AudioTemplateProps & AudioProps> = (props): ReactElement => (
  <Fragment>
    {isBrowser() ? (
      <Suspense fallback={<AudioPlayerTemplate />}>
        <AudioPlayer {...props} />
      </Suspense>
    ) : (
      <AudioPlayerTemplate />
    )}
  </Fragment>
);

export default Audio;
